export function LoadingBar() {
  return (
    <>
      <style>
        {`
          @keyframes progress {
            0% {
              transform: translateX(0) scaleX(0);
            }
            40% {
              transform: translateX(0) scaleX(0.4);
            }
            100% {
              transform: translateX(100%) scaleX(0.5);
            }
          }
        `}
      </style>
      <div className="absolute top-0 left-0 w-full z-[11]">
        <div className="h-[3px] w-full bg-orange-50 overflow-hidden">
          <div className="[animation:progress_1000ms_ease-in-out_infinite] [transform-origin:left_center] w-full h-full bg-orange-500" />
        </div>
      </div>
    </>
  )
}
